import { render } from "./Step.vue?vue&type=template&id=16e6a678"
import script from "./Step.vue?vue&type=script&lang=js"
export * from "./Step.vue?vue&type=script&lang=js"
script.render = render

export default script